import React from 'react';

import styled from 'styled-components';

const TickWrapper = styled.span`
    box-sizing: border-box;
    margin: ${(props) => (props.$margin ? props.$margin : 0)};
    padding: 0;
    color: rgba(0, 0, 0, 0.75);
    font-size: 15px;
    font-variant: none;
    line-height: 1.5715;
    list-style: none;
    font-feature-settings:
        'ss01',
        'case' on,
        'kern' off;
    position: relative;
    display: inline-block;
    line-height: inherit;
    vertical-align: baseline;

    .tick-inner {
        position: relative;
        top: -1px;
        display: inline-block;
        width: 12px;
        height: 12px;
        vertical-align: middle;
        color: ${(props) => props.theme.SuccessColor};
        font-size: 12px;
        line-height: 1;
    }
`;

const AcknowledgmentTick = ({ ackn, mg }) => {
    if (ackn && ackn === 'Checked') {
        return (
            <TickWrapper $margin={mg}>
                <span className="tick-inner">✓</span>
            </TickWrapper>
        );
    }
    return null;
};

export { AcknowledgmentTick };
